import { instance } from '@/api'
import { throwResponseError } from '@/utils/error/throwResponseError'

const REPORT_URL = 'report'

export const ReportApi = {
  async getBy (type, params, format = 'pdf') {
    try {
      return await instance.get(`/${REPORT_URL}/${type}`, {
        params: {
          ...params,
          format
        },
        responseType: 'blob'
      })
    } catch (e) {
      throwResponseError(e, 'Не удалось получить документ')
    }
  }
}
